(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["specifications"] && !Shopify.designMode) return;
  try {
    
  function specifications_scrollspy() {
    const container = document.getElementById("spec-content-desktop");
    if (!container) return;
    const sections = container.querySelectorAll("section");
    const navLinks = document.querySelectorAll(".specifications-sidebar .nav-link");

    function updateActiveLink() {
      const scrollTop = container.scrollTop + 80;
      let currentSectionId = null;

      sections.forEach((section) => {
        const sectionTop = section.offsetTop - container.offsetTop;
        const sectionHeight = section.offsetHeight;
        if (scrollTop >= sectionTop - 10 && scrollTop < sectionTop + sectionHeight - 10) {
          currentSectionId = section.id;
        }
      });

      navLinks.forEach((link) => {
        const targetId = link.getAttribute("data-target");
        link.classList.toggle("active", targetId === currentSectionId);
      });
    }

    container.addEventListener("scroll", updateActiveLink);
    updateActiveLink();
  }

  function specifications_sidebar() {
    document.querySelectorAll('.specifications-sidebar .nav-link').forEach(link => {
      link.addEventListener('click', function () {
        const targetId = this.getAttribute('data-target');
        const targetEl = document.getElementById(targetId);
        const container = document.getElementById('spec-content-desktop');
        if (targetEl && container) {
          container.scrollTo({ top: targetEl.offsetTop, behavior: 'smooth' });
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    specifications_scrollspy();
    specifications_sidebar();
  });

  } catch(e) { console.error(e); }
})();
})();
